﻿import { FIQAssist } from "../app";
import { IParent, IChild, IMediator } from "../interfaces/IParentChild";
import { Toggleswitch } from "./toggleswitch";
import { Component, Input, Output, Inject, Attribute } from "@fiqas/angular-utils";

@Component({
    module: FIQAssist,
    selector: 'checklist',
    template: `<div class="checklist ng-class:{readonly:$ctrl.readOnly}">

                    <div ng-class="{hovered:$ctrl.allHovered}" class="checkitemall" ng-show="$ctrl.showAllOption" ng-mousedown="$ctrl.itemallclick($event)">
                        <toggleswitch ignore-keys="true" read-only="true" key="" tab-index="-1" active="$ctrl.allclicked" activechanged="$ctrl.itemallchanged(source, active)"></toggleswitch>
                        <span class="label">{{ $ctrl.allText | translate}}</span>
                    </div>

                    <div class="checklistitems">

                        <div ng-class="{hovered:item.hovered}" class="checkitem" ng-repeat="item in $ctrl._items" ng-mousedown="$ctrl.itemclick($event, item)">
                            <toggleswitch ignore-keys="true" read-only="true" tab-index="-1" key="item.key" parent="$ctrl" mediator="item" active="item.checked"></toggleswitch>
                            <span class="label" ng-attr-title="{{item.text}}">{{item.text}}</span>
                        </div>
                    <div>
               </div>`
})
export class Checklist implements IParent {

    constructor(
        @Inject('$element') private $element: angular.IRootElementService
    ) {
    }

    @Input() public readOnly: boolean;

    private isInitialized: boolean = false;

    private _toggles: Toggleswitch[] = [];

    public addChild(child: IChild) {
        if (this._toggles.filter(o => o == child).length == 0)
            this._toggles.push(<Toggleswitch>child);
    }

    public removeChild(child: IChild) {
        this._toggles = this._toggles.filter(x => x != <Toggleswitch>child);
    }

    public focusChild(child: IChild): void {
        this._items.forEach(x => x.hovered = x.child === child)
    }

    public positionOfFocus(offsetTop: number): void {
        var halfway = (<HTMLElement>this.$element[0].getElementsByClassName('checklistitems').item(0)).clientHeight / 2;
        (<HTMLElement>this.$element[0].getElementsByClassName('checklistitems').item(0)).scrollTop = offsetTop - halfway;
    }

    public children(): IChild[] {
        return this._toggles;
    }

    public $onInit() {
        this.isInitialized = true;
        var res = this._items.filter(o => o.checked).map(i => { return { key: i.key, text: i.text }; });
        this.onSelectionChanged({ selected: res });
        this.allText = this.allText || "SELECT_ALL_CUSTOMERS";
    }

    @Input() public get items(): checklistitem[] {
        return this._items;
    }
    public set items(value: checklistitem[]) {
        this._items = value;
        this.items.forEach(x => x.hovered = false);
    }

    private _showall = false;
    @Attribute() public get showAllOption() {
        return this._showall;
    }
    public set showAllOption(val: boolean | string) {
        this._showall = val === "true" || val === true;
    }
    @Input() public allHovered: boolean;

    @Input() public allSubset: string[];
    @Input() public allText: string;

    @Output() public onselectionchanged: (args: { selected: { key: any, text: string }[] }) => void;

    @Output() public onitemselected: (args: { key: any, text: string }) => void;

    private onSelectionChanged(args: { selected: { key: any, text: string }[] }) {
        if (this.readOnly) return;
        this.onselectionchanged(args);
    }

    private _items: checklistitem[] = [];

    private subsetFilter = i => !this.allSubset || this.allSubset.length == 0 || this.allSubset.some(e => e == i.key);

    public itemclick($event: JQueryEventObject, item: checklistitem) {
        $event.preventDefault();
        if (this.readOnly) return;
        var toggle = this._toggles.filter(t => t.key == item.key).shift();
        toggle.active = !toggle.active;
        toggle.hasfocus = true;
        this.itemtoggle(item, toggle.active);
        this.updateSelectionChanged();
        this.onitemselected({ key: item.key, text: item.text });
    }

    public itemallclick(event: JQueryEventObject) {
        event.preventDefault();
        if (this.readOnly) return;

        this.$element[0].querySelector('.toggleswitch').focus();

        if (this.allclicked) {
            this._toggles.forEach(t => t.active = false)
            this._items.forEach(t => t.checked = false)
        } else {
            this._toggles.forEach(t => t.active = this.subsetFilter(t));
            this._items.forEach(t => t.checked = this.subsetFilter(t));
        }
        this.updateSelectionChanged();
        this.onitemselected({ key: "allselected", text: '' });
    }

    public get allclicked(): boolean {
        return this._toggles.length > 0 && !this._toggles.filter(this.subsetFilter).some(x => !x.active) && !this._toggles.filter(i => !this.subsetFilter(i)).some(x => x.active);
    }

    private updating: boolean = false;

    public itemallchanged(source: Toggleswitch, selected: boolean) {
        if (selected) {
            if (this.allSubset && this.allSubset.length > 0) {
                this._toggles.forEach(x => x.active = false);
                this._items.forEach(x => x.checked = false);
            }  else if (!this._toggles.filter(this.subsetFilter).some(x => !x.active)) {
                this._toggles.filter(this.subsetFilter).forEach(x => x.active = false);
                this._items.filter(this.subsetFilter).forEach(x => x.checked = false);
            }
            this._toggles.filter(this.subsetFilter).forEach(x => x.active = selected);
            this._items.filter(this.subsetFilter).forEach(x => x.checked = true);
        }

        this.updateSelectionChanged();
    }



    public itemtoggle(source: checklistitem, active: boolean) {
        source.checked = active;
        this.updateSelectionChanged();
    }

    public imagePicture(checked: boolean): string {
        return checked ? "css/images/checkliston.png" : "css/images/checklistoff.png";
    }

    private oldSel: { key: any, text: string }[] = null;

    private updateSelectionChanged() {
        if (this.isInitialized) {
            var current = this.makeSelectionSet();
            if (!this.areEqual(this.oldSel, current)) {
                this.onSelectionChanged({ selected: this.makeSelectionSet() });
                this.oldSel = current;
            }
        }
    }

    private makeSelectionSet(): { key: any, text: string }[] {
        var res = this._toggles.filter(o => o.active)
            .map(i => {
                return { key: i.key, text: this.getText(i.key) };
            });
        return res;
    }

    private getText(key: any): string {
        var s = this._items.filter(p => p.key == key);
        if (s.length > 0) return s[0].text;
        return '';
    }

    private areEqual(old: { key: any, text: string }[], current: { key: any, text: string }[]): boolean {
        if (old == null)
            return false;

        if (old.length != current.length)
            return false;

        return old.every(x => current.some(y => x.key == y.key));
    }
}

export class checklistitem implements IMediator {
    public checked: boolean;
    public key: any;
    public text: string;
    public hovered?: boolean;

    public parent: IParent;
    public child: IChild;
}
